import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaticPageLayoutComponent } from '../static-page-layout/static-page-layout.component';
import { AppIconComponent } from '../../shared-components/icon/icon.component';

@Component({
  selector: 'app-about-ciranet',
  standalone: true,
  imports: [CommonModule, StaticPageLayoutComponent, AppIconComponent],
  templateUrl: './about-ciranet.component.html',
  styleUrls: ['./about-ciranet.component.scss']
})
export class AboutCiranetComponent {}
